// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__or2GL","messages":"Chat_messages__5f_C9","dateDivider":"Chat_dateDivider__1oaIY"};